/*
 * Wishlist Header Connector
 * Connects the custom header wishlist icon
 * to the existing Wishlist Hero header trigger.
 */

(function () {
  'use strict';

  if (window.__VinherWishlistHeaderLoaded) {
    return;
  }

  window.__VinherWishlistHeaderLoaded = true;

  /*
   * Find the native Wishlist Hero header trigger.
   *
   * Wishlist Hero normally creates:
   * .wishlist-hero-header-icon
   */
  function findNativeWishlistHeader() {
    var nativeWishlist = document.querySelector(
      '.wishlist-hero-header-icon'
    );

    if (nativeWishlist) {
      return nativeWishlist;
    }

    /*
     * Fallback selectors in case the Wishlist Hero
     * markup changes.
     */
    var selectors = [
      '[href="#hero-wishlist"]',
      '[data-wishlist-hero]',
      '[data-wishlist]',
      '[class*="wishlisthero"]',
      '[class*="wishlist-hero"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var element = document.querySelector(selectors[i]);

      if (element) {
        return element;
      }
    }

    return null;
  }

  /*
   * Trigger the native Wishlist Hero functionality.
   */
  function triggerWishlist() {
    var nativeWishlist = findNativeWishlistHeader();

    if (!nativeWishlist) {
      console.warn(
        'Wishlist: native Wishlist Hero header trigger was not found.'
      );

      /*
       * Fallback:
       * If the Wishlist Hero target exists, open it
       * through the URL hash.
       */
      var wishlistTarget = document.querySelector(
        '[href="#hero-wishlist"]'
      );

      if (wishlistTarget) {
        try {
          wishlistTarget.click();
          return true;
        } catch (error) {
          console.warn(
            'Wishlist fallback click failed.',
            error
          );
        }
      }

      if (
        document.getElementById('hero-wishlist')
      ) {
        window.location.hash = 'hero-wishlist';
        return true;
      }

      return false;
    }

    try {
      nativeWishlist.click();
      return true;
    } catch (error) {
      console.warn(
        'Wishlist header click failed.',
        error
      );

      return false;
    }
  }

  /*
   * Bind the custom header wishlist button.
   */
  function bindWishlistHeader() {
    var wishlistButton = document.querySelector(
      '[data-vinher-wishlist-header-trigger]'
    );

    if (!wishlistButton) {
      return;
    }

    if (
      wishlistButton.dataset.wishlistHeaderBound === 'true'
    ) {
      return;
    }

    wishlistButton.dataset.wishlistHeaderBound = 'true';

    wishlistButton.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        var opened = triggerWishlist();

        if (opened) {
          wishlistButton.classList.add(
            'is-active'
          );

          setTimeout(function () {
            wishlistButton.classList.remove(
              'is-active'
            );
          }, 300);
        }
      }
    );
  }

  /*
   * Initial binding.
   */
  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      bindWishlistHeader
    );
  } else {
    bindWishlistHeader();
  }

  /*
   * Shopify/Wishlist Hero can inject elements
   * after the page has loaded, so watch for changes.
   */
  if (
    typeof MutationObserver !== 'undefined'
  ) {
    var observer = new MutationObserver(
      function () {
        bindWishlistHeader();
      }
    );

    function startObserver() {
      if (!document.body) {
        return;
      }

      observer.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );
    }

    if (
      document.readyState === 'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        startObserver,
        {
          once: true
        }
      );
    } else {
      startObserver();
    }
  }
})();